import { render, staticRenderFns } from "./QuizJoinGameForm.vue?vue&type=template&id=035374dd&scoped=true&"
import script from "./QuizJoinGameForm.vue?vue&type=script&lang=js&"
export * from "./QuizJoinGameForm.vue?vue&type=script&lang=js&"
import style0 from "./QuizJoinGameForm.vue?vue&type=style&index=0&id=035374dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035374dd",
  null
  
)

export default component.exports